import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";

export default function Confidentialite() {
  return (
    <div className="min-h-screen bg-[#f8faff] text-[#1a2332] font-body">
      <Seo title="Politique de confidentialité | DDSBillancourt" path="/confidentialite" />
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-16 md:py-24">
        <Link to="/" className="inline-flex items-center gap-2 text-[#5b6577] hover:text-[#00a86b] text-sm font-headings font-semibold mb-8" data-testid="privacy-back">
          <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
        </Link>
        <h1 className="font-headings font-black text-4xl md:text-5xl tracking-tight">Politique de confidentialité</h1>
        <p className="mt-3 text-[#5b6577]">DDSEmpire — Dynastie Drive School s'engage à protéger la vie privée de ses élèves et visiteurs conformément au RGPD (Règlement (UE) 2016/679) et à la loi Informatique et Libertés du 6 janvier 1978 modifiée.</p>

        <div className="mt-10 space-y-8">
          <S title="1. Responsable du traitement">
            DDSEmpire — Dynastie Drive School, 37 Avenue Édouard Vaillant, 92100 Boulogne-Billancourt. Email : dynastieblb@gmail.com. Téléphone : 01 41 31 50 61.
          </S>
          <S title="2. Données collectées">
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li><strong>Formulaire de contact :</strong> nom, prénom, email, téléphone, formation souhaitée, message.</li>
              <li><strong>Inscription auto-école :</strong> adresse postale, date de naissance, NEPH, photo d'identité, copies de pièces administratives.</li>
              <li><strong>Plateforme e-learning :</strong> identifiant, mot de passe haché (bcrypt), progression, résultats aux quiz, empreinte navigateur (device fingerprint anti-fraude).</li>
              <li><strong>Données de navigation :</strong> adresse IP, type de navigateur, pages visitées, durée de session.</li>
            </ul>
          </S>
          <S title="3. Finalités du traitement">
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li>Gérer l'inscription et le suivi pédagogique de l'élève</li>
              <li>Fournir l'accès à la plateforme e-learning et tracer la progression</li>
              <li>Répondre aux demandes via le formulaire de contact</li>
              <li>Envoyer des informations sur les formations et offres</li>
              <li>Établir le classement Légende du jeu concours</li>
              <li>Améliorer le service par analyse statistique anonymisée</li>
            </ul>
          </S>
          <S title="4. Base légale">
            Les traitements sont fondés sur l'exécution du contrat de formation (article 6.1.b RGPD), le consentement exprès pour les communications commerciales (article 6.1.a RGPD), et l'intérêt légitime de l'auto-école pour la sécurité (anti-fraude, audit).
          </S>
          <S title="5. Durée de conservation">
            Données pédagogiques : 3 ans après la fin de la relation contractuelle (durée légale de conservation des contrats de formation). Données de prospection : 3 ans après le dernier contact. Logs de connexion : 12 mois.
          </S>
          <S title="6. Destinataires">
            Les données sont destinées exclusivement au personnel autorisé de DDSEmpire (moniteurs, administrateurs, super administrateur). Aucune cession à des tiers commerciaux. Les données peuvent être communiquées aux autorités administratives sur demande légale (préfecture, ANTS, justice).
          </S>
          <S title="7. Sécurité">
            Mots de passe hachés en bcrypt, communications HTTPS chiffrées, authentification JWT à durée limitée (7 jours), verrouillage anti-cheat sur empreinte navigateur, sauvegardes régulières de la base de données.
          </S>
          <S title="8. Vos droits">
            Vous disposez à tout moment des droits suivants :
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li>Accès à vos données et copie</li>
              <li>Rectification ou complétion</li>
              <li>Effacement (« droit à l'oubli »)</li>
              <li>Limitation du traitement</li>
              <li>Portabilité (export structuré)</li>
              <li>Opposition au traitement</li>
              <li>Retrait du consentement à tout moment</li>
              <li>Réclamation auprès de la CNIL (cnil.fr)</li>
            </ul>
            <p className="mt-3">Pour exercer ces droits, écrivez-nous à <strong>dynastieblb@gmail.com</strong> en justifiant de votre identité.</p>
          </S>
          <S title="9. Cookies et mesure d&apos;audience">
            <p>Le site utilise des cookies fonctionnels strictement nécessaires (token JWT pour l&apos;authentification, préférences, état du Service Worker PWA), qui ne requièrent pas de consentement.</p>
            <p className="mt-2">
              Avec votre consentement explicite (bandeau cookies « Tout accepter »), nous chargeons également :
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li><strong>Microsoft Clarity</strong> — analyse de parcours anonymisée (cartes de chaleur, enregistrements de session sans données personnelles).</li>
              <li><strong>Google Ads (gtag.js)</strong> — mesure des conversions publicitaires (soumissions de formulaire, appels téléphoniques depuis le site).</li>
            </ul>
            <p className="mt-3">
              <strong>Suivi avancé des conversions (Google Enhanced Conversions)</strong> : lorsque vous soumettez un formulaire de contact et que vous avez accepté les cookies analytics, votre adresse email et votre numéro de téléphone sont <strong>hachés en SHA-256 dans votre navigateur</strong> avant d&apos;être transmis à Google Ads. Le hachage est <strong>irréversible</strong> : Google ne reçoit jamais vos données en clair. Cette mesure améliore la précision de l&apos;attribution de nos campagnes publicitaires. Vous pouvez à tout moment retirer ce consentement en cliquant à nouveau sur « Refuser » depuis le bandeau cookies, ou en réinitialisant votre choix depuis les paramètres de votre navigateur.
            </p>
            <p className="mt-2 text-sm">
              Base légale : article 82 loi Informatique et Libertés (consentement) — durée de conservation des identifiants Google Ads : 540 jours (par défaut, paramétrable par Google).
            </p>
          </S>
        </div>

        <div className="mt-14 pt-8 border-t border-black/10 text-xs text-[#5b6577]">
          Dernière mise à jour : 7 juillet 2026 · DDSEmpire — Dynastie Drive School
        </div>
      </div>
    </div>
  );
}

function S({ title, children }) {
  return (
    <section>
      <h2 className="font-headings font-black text-xl md:text-2xl text-[#1a2332] mb-2">{title}</h2>
      <div className="text-[#3a4858] leading-relaxed">{children}</div>
    </section>
  );
}
